<!--负荷图表-->
<template>
  <div class="realTimeLoadBody" :style="backImg('/huapu/discountBox.png')">
    <vchart ref='vchartLine' themes="purple-passion"></vchart>
  </div>
</template>

<script>
  import resourcesStore from '@/cache/resourcesStore.js'
  import vchart from '@/components/module/chart/vchart.vue'
  export default {
    components: {
      vchart,
    },
    data () {
      return {
        todayLoadLine: [
          {
            data: [24.10,24.11,26.13,34.23,45.56,67.65,32.21,24.10,24.11,26.13,34.23,45.56,34.53],

            lineStyle: {
              color: '#ded45e'
            },
            itemStyle: {
              color: '#ded45e',
            },
            showSymbol: false,
            type: 'line',
            name: '今日负荷'
          },{
            data: [25.11,24.15,25.15,35.25,44.54,64.64,34.24,24.13,23.13,24.13,34.25,44.564,35.55],

            lineStyle: {
              color: '#4d89b0'
            },
            itemStyle: {
              color: '#4d89b0',
            },
            showSymbol: false,
            type: 'line',
            name: '昨日负荷'
          },{
            data: [22.12,22.12,22.12,32.22,42.52,62.62,32.22,22.12,22.12,22.12,32.22,42.52,32.52],

            lineStyle: {
              color: '#a363d6'
            },
            itemStyle: {
              color: '#a363d6',
            },
            showSymbol: false,
            type: 'line',
            name: '前日负荷'
          },
        ],

      }
    },
    mounted () {
      this.init()
    },
    watch: {
      nowUnit (nv,ov) {
        this.init();
      },
    },
    computed: {
      backImg () {
        return this.$store.resourcesStore.getters.getBackgroudImageStyle
      },
      nowUnit () {//总id
        return this.$store.unitStore.getters.getNowUnit
      },
    },

    methods: {
      init () {
        this.getList2() //负荷数据 
        this.$refs.vchartLine.setData({
          toolbox: {
            top: 12,
            right:13,
            show: true,
              iconStyle: {
                            borderColor: "#94d6da"

                        },
            feature: {
              magicType: {type: ['line','bar']},
              restore: {},
              saveAsImage: {}
            }
          },
          dataZoom: [
            {
              type: 'inside',
              start: 0,
              end: 10
            },
            {
              start: 0,
              end: 10
            }
          ],
          tooltip: {
            trigger: 'axis'
          },
          xAxis: {
            type: 'category',
            axisLabel: {
              textStyle: {
                color: '#fff'
              },
            },
            axisLine: {
              show: true

            },
            data: ['00:00','02:00','04:00','06:00','08:00','10:00','12:00','14:00','16:00','18:00','20:00','22:00','24:00'],
          },
          yAxis: {
            type: 'value',
            nameTextStyle: {
              color: '#FFF',
            },
            axisLabel: {
              textStyle: {
                color: '#fff'
              },
            },
            axisLine: {
              show: true
            },
          },
          legend: {
            data: [{
              name: '昨日负荷',
              textStyle: {
                color: '#4d89b0'
              }
            },{
              name: '今日负荷',
              textStyle: {
                color: '#ded45e'
              }
            },{
              name: '前日负荷',
              textStyle: {
                color: '#a363d6'
              }
            }],
            top: 20
          },
          backgroundColor: '',
          series: this.todayLoadLine
        })

      },
      xList () {//288
        var list=[]
        for(var h=0,len=24;h<len;h++) {
          for(var m=0,lenm=60;m<lenm;m+=5) {
            list.push((h<10? '0':'')+h+':'+(m<10? '0':'')+m)
          }
        }
        return list
      },
      getList2 () {//获取负荷数据
        this.$api.powerApi.getUnitDayLoadValues(this.$store.unitStore.getters.getNowUnit.id,new Date(getDay(-2)+' 00:00:00').getTime(),respon => {

          this.todayLoadLine[2].data=respon  //前日负荷
          this.$api.powerApi.getUnitDayLoadValues(this.$store.unitStore.getters.getNowUnit.id,new Date(getDay(-1)+' 00:00:00').getTime(),respon => {


            this.todayLoadLine[1].data=respon  //昨日负荷
            this.$api.powerApi.getUnitDayLoadValues(this.$store.unitStore.getters.getNowUnit.id,new Date(getDay(0)+' 00:00:00').getTime(),respon => {

              this.todayLoadLine[0].data=respon  //今日负荷
              this.$refs.vchartLine.setData({
                xAxis: {
                  type: 'category',
                  axisLabel: {
                    textStyle: {
                      color: '#fff'
                    },
                  },
                  axisLine: {
                    show: true

                  },
                  data: this.xList(),
                },
                yAxis: {
                  type: 'value',
                  nameTextStyle: {
                    color: '#FFF',
                  },
                  axisLabel: {
                    textStyle: {
                      color: '#fff'
                    },
                  },
                  axisLine: {
                    show: true

                  },
                },
                legend: {
                  data: [{
                    name: '昨日负荷',
                    textStyle: {
                      color: '#4d89b0'
                    }
                  },{
                    name: '今日负荷',
                    textStyle: {
                      color: '#ded45e'
                    }
                  },{
                    name: '前日负荷',
                    textStyle: {
                      color: '#a363d6'
                    }
                  }],
                  top: 20
                },
                backgroundColor: '',
                series: this.todayLoadLine
              })
            })

          })
        })


      },

    }
  }
</script>

<style scoped>
  .realTimeLoadBody {
    width: calc(100% - 20px);
    margin: 10px;
    height: calc(100% - 20px);
  }

  .realTimeLoadBody .default-chart {
    height: 100%;
    width: 100%;
  }
</style>